export default function getResource(label, vars = []) {
    const resources = {
        addToBasketShort: 'Ajouter',
        remove: 'Supprimer',
        signInToAccess: 'Accéder au compte',
        exclusive: 'Exclusivement'
    };
    return resources[label];
}
